<section
  class="MainDiv box-border flex flex-wrap pl-16 py-8 mx-auto my-0 w-full max-sm:max-w-screen-sm max-md:px-5 max-md:py-0"
>
  <header
    class="flex flex-wrap gap-10 mb-4 mt-2 justify-between items-center w-full max-w-full"
  >
    <h2
      class="text-2xl font-bold text-black leading-8 max-md:text-lg max-md:leading-7 max-sm:text-base max-sm:leading-6"
    >
      Most Search Models
    </h2>
    <a
      (click)="seeMoregotoProductList('mostSearchedModels')"
      class="viewAll flex text-base font-bold text-blue-500 text-center leading-6 max-md:text-sm max-md:leading-5 max-sm:text-xs max-sm:leading-4 max-sm:mt-2 md:mr-14 cursor-pointer"
    >
      View all
    </a>
  </header>
  <div class="relative mb-10 w-full">
    <!-- Removed overflow-hidden from this container -->
    <div class="overflow-hidden">
      <!-- Added new div with overflow-hidden -->
      <div
        class="flex gap-6 transition-transform duration-[0.3s] ease-[ease-in-out] max-md:gap-4 max-sm:gap-3"
        [ngStyle]="{
          transform: 'translateX(-' + currentSlide * (slideWidth + gap) + 'px)',
        }"
      >
        <!-- Outer scroll container -->
        <div class="w-full overflow-x-auto md:overflow-visible scrollbar-hide">
          <!-- Inner scrollable track -->
          <div
            class="flex gap-3 md:gap-5 md:transition-transform md:duration-[0.3s] md:ease-[ease-in-out] flex-nowrap"
          >
            <!-- Unified Responsive Article -->
            <article
              *ngFor="let vehicle of vehicles"
              (click)="gotoproductList(vehicle)"
              class="ImgContainer overflow-hidden bg-white rounded-lg h-full min-w-[198px] md:max-w-[224px] xl:min-w-[350px] flex flex-col shrink-0 cursor-pointer"
            >
              <img
                [src]="
                  vehicle?.image_path
                    ? vehicle?.image_path
                    : 'https://cdn.builder.io/api/v1/image/assets/TEMP/d7731c2d918afe92e7a24deb13728d712fdfa181?placeholderIfAbsent=true'
                "
                [alt]="vehicle?.model"
                class="w-full rounded-lg object-contain aspect-[1.35] md:aspect-auto md:h-[230px] md:object-cover"
              />
              <div class="p-2 md:p-4 flex flex-col justify-between flex-1">
                <h3
                  class="text-sm md:text-lg font-bold text-black leading-5 md:leading-6 mb-1 md:mb-2 md:-ml-4 md:mb-4"
                >
                  {{ vehicle?.make }}, {{ vehicle?.model }}
                </h3>
                <div
                  class="flex flex-col xl:flex-row md:items-center text-xs md:text-sm text-gray-500 gap-1 xl:-ml-4 md:gap-2 cursor-pointer"
                >
                  <span class="md:-ml-[121px] md:-mb-2 xl:-ml-0 xl:-mb-0"
                    >{{ vehicle?.parts_available }} Parts Available</span
                  >
                  <span
                    class="hidden xl:inline-block w-1 h-1 bg-gray-400 rounded-full"
                    *ngIf="vehicle?.parts_available > 1"
                  ></span>
                  <span class="md:-ml-[74px] xl:-ml-0">
                    {{
                      +(vehicle?.grade_a_percent || "").replace("%", "") > 0
                        ? vehicle?.grade_a_percent + " are Grade A parts"
                        : +(vehicle?.grade_b_percent || "").replace("%", "") > 0
                          ? vehicle?.grade_b_percent + " are Grade B parts"
                          : +(vehicle?.grade_c_percent || "").replace("%", "") >
                              0
                            ? vehicle?.grade_c_percent + " are Grade C parts"
                            : ""
                    }}
                  </span>
                </div>
              </div>
            </article>
          </div>
        </div>
      </div>
    </div>

    <!-- Navigation buttons -->
    <div class="flex justify-between items-center w-full max-sm:hidden">
      <button
        class="flex justify-center items-center w-10 h-10 rounded-lg transition-all cursor-pointer duration-[0.3s] ease-[ease] shadow-[0_4px_12px_rgba(0,0,0,0.15)] z-[1] hover:transform hover:-translate-x-2 absolute left-0 top-[150px] -translate-y-1/2 leftBtn"
        (click)="prev()"
        [ngStyle]="{
          background: currentSlide === 0 ? '#ccc' : '#307FE1',
          pointerEvents: currentSlide === 0 ? 'none' : 'auto',
          opacity: currentSlide === 0 ? 0.5 : 1,
        }"
        aria-label="Previous slide"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15 18L9.70711 12.7071C9.31658 12.3166 9.31658 11.6834 9.70711 11.2929L15 6"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
        </svg>
      </button>
      <button
        class="flex justify-center items-center w-10 h-10 rounded-lg transition-all cursor-pointer duration-[0.3s] ease-[ease] shadow-[0_4px_12px_rgba(0,0,0,0.15)] z-[1] hover:transform hover:translate-x-2 absolute right-0 top-[150px] -translate-y-1/2 rightBtn"
        (click)="next()"
        [ngStyle]="{
          background:
            currentSlide === totalSlides - visibleSlides ? '#ccc' : '#307FE1',
          pointerEvents:
            currentSlide === totalSlides - visibleSlides ? 'none' : 'auto',
          opacity: currentSlide === totalSlides - visibleSlides ? 0.5 : 1,
        }"
        aria-label="Next slide"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9 6L14.2929 11.2929C14.6834 11.6834 14.6834 12.3166 14.2929 12.7071L9 18"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
        </svg>
      </button>
    </div>
  </div>
</section>
